import { rubriekenFp, rubriekFp } from "domain/rubriek";
import { RubriekReducer } from "domain/store/rubriekenReducer";
import { either, option, reader } from "fp-ts";
import { constFalse, flow, pipe } from "fp-ts/lib/function";

export interface WARNING_PARTNER_CODES_FILLED_IN_FOR_SINGLE_AANGIFTE {
  type: "WARNING_PARTNER_CODES_FILLED_IN_FOR_SINGLE_AANGIFTE";
  partnerCodes: string[];
}

const hasAnsweredYes = (code: string, rubrieken: RubriekReducer): boolean => {
  return pipe(rubrieken, rubriekenFp.lookupValue<boolean>(code), option.getOrElse(constFalse));
};

const hasAnsweredNo = flow(hasAnsweredYes, (b) => !b);

const isSingle = (rubrieken: RubriekReducer) => {
  return (
    hasAnsweredYes("1001", rubrieken) ||
    hasAnsweredYes("1003", rubrieken) ||
    hasAnsweredYes("1010", rubrieken) ||
    (hasAnsweredYes("1018", rubrieken) && hasAnsweredNo("1019", rubrieken)) ||
    hasAnsweredYes("1022", rubrieken)
  );
};
export const init = flow(isSingle, (b) => !b);

const checkChangingToSingleAangifteWithPartnerCodesFilledIn = (prevState: boolean) => (nextState: boolean) => (
  rubrieken: RubriekReducer
) => {
  if (nextState || prevState === nextState) return either.right(nextState);

  const filledInPartnerCodes = pipe(
    rubrieken,
    rubriekenFp.filterWithIndex(
      (code, rubriek) => rubriekFp.hasValue(rubriek) && rubriekFp.isPartnerRubriek(code, rubriek)
    )
  );

  if (rubriekenFp.isEmpty(filledInPartnerCodes)) return either.right(nextState);

  return either.left({
    type: "WARNING_PARTNER_CODES_FILLED_IN_FOR_SINGLE_AANGIFTE",
    partnerCodes: [...filledInPartnerCodes.keys()],
  } as WARNING_PARTNER_CODES_FILLED_IN_FOR_SINGLE_AANGIFTE);
};

export const derive = (prevState: boolean) => (rubrieken: RubriekReducer) => {
  return pipe(
    isSingle,
    reader.map((s) => !s),
    reader.chain(checkChangingToSingleAangifteWithPartnerCodesFilledIn(prevState))
  )(rubrieken);
};
